<section class="p-b-16">
    <div fxLayout="row" fxLayoutGap="8px" class="m-t-16 no print">
      <button [disabled]="!disableExport" type="button" mat-stroked-button color="primary" (click)="exportToPdf(pdfCert, pdfBadge, pdfLetter)">
        Export to PDF
      </button>
  
      <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
      <input type="file" (change)="onFileSelected($event)" accept="image/*" *ngIf="selectedBadges"/>
    </div>
    <div class="text-red-400" *ngIf="!disableExport"><span class="text-red-400"><strong>Certificate Number is invalid.</strong></span></div>
  </section>
  <mat-dialog-content>
    <kendo-pdf-export #pdfCert paperSize="letter" [scale]="1.05" margin="1cm" forcePageBreak=".page-break" [landscape]=true>
      <div *ngIf="selectedCertificates" fxLayout="column" class="body">
        <div class="middle-border">
          <div class="certificate">
            <div class="inner-border">              
              <h1 style="margin-top: 9px;">State of Oregon</h1>
              <h1>Oregon Health Authority</h1>
              <p style="font-size:20px"><strong >{{personCertificateModel.firstName}} {{personCertificateModel.lastName}}</strong></p>
              <p>
                is certified by the Oregon Health Authority to conduct<br>
                Lead-Based Paint Activities in the State of Oregon
              </p>
              <p style="font-size:20px"><strong>{{personCertificateModel.codeType}}</strong></p>
              <div class="signature">                                      
                <p style="margin-bottom:0;">Certification Number : {{personCertificateModel.certificationNumber}}</p>
                <p style="margin : 0; padding-top:0;">Issuance Date : {{personCertificateModel.issueDate  | date: 'MM/dd/yyyy'}} </p>
                <p style="margin : 0; padding-top:0;">Expiration Date : {{personCertificateModel.expirationDate | date: 'MM/dd/yyyy'}}</p>
              </div>
              <div class="wrap">
                <img src="../../../../../assets/images/ORSeal1.png" style="width: 12%; left: 4%; bottom: 27%; transform: scale(1.3125)" alt="Official Seal of the Organization"/>
                <img src="../../../../../assets/images/ohaLogoTransparent.png" style="width: 37%; right: 2.1%; bottom: calc(38.5% - 12px);" alt="Official Logo of the Organization"/>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </kendo-pdf-export>
    <div *ngIf="(selectedBadges || selectedLetters) && selectedCertificates">
      <br><br><br><br>
    </div>  
   
    <kendo-pdf-export #pdfBadge paperSize="letter" [scale]="0.75" margin="0.5cm" forcePageBreak=".page-break">   
      <div *ngIf="selectedBadges" class="page-border">   
        <div class="page-one badge" style="border: 7px solid #005595;">               
          <img src="../../../../../assets/images/transparentSeal.png" alt="Watermark" class="watermark" /> 
          <div class="badge-container">
            <div *ngIf="badgeImageUrl" class="badge-picture" [ngStyle]="{'background-image': 'url(' + badgeImageUrl + ')'}"></div>
          </div>
          <div class="certified-div">
            <p class="certified-text">
              CERTIFIED
            </p>
          </div>
          <p><span class="name">{{personCertificateModel.firstName}} {{personCertificateModel.lastName}}</span></p>
          <p class="code-type">{{personCertificateModel.codeType}}</p>
          <p class="cert-label">Lead Based Paint Activities</p>
          <p class="cert-text">CERTIFICATION:</p>
          <p class="cert-number">#{{personCertificateModel.certificationNumber}}</p>
          <p class="cert-date">Expires: {{personCertificateModel.expirationDate | date: 'MM/dd/yyyy'}}</p>
        </div>      
      </div>
      <div *ngIf="selectedBadges" class="page-break">
        <br><br>
      </div>  
      <div class="page page-two" *ngIf="selectedBadges" style="margin-left: auto; border: 0px solid white; display: flex;">    
        <div style="transform: rotate(270deg);">
          <p class="badge-back-text">This certification is issued to the individual named on the reverse under the authority of ORS 431A.355 and OAR 333-069.</p>
          <p class="badge-back-text">This badge must be carried on the certified individual while physically present at any lead-based paint regulated activity.</p>
          <p class="badge-back-text">This is valid for the period listed on the reverse and can be renewed by completing a renewal application and providing a refresher training within 12 months of the application. Expired certification will need to re-apply as an initial application.</p>
          <p class="badge-back-text">If found, this badge can be returned to: Oregon Health Authority 800 NE Oregon St. Suite 640 Portland, OR 97232</p>
        </div>
      </div>  
    </kendo-pdf-export>
    <div *ngIf="(selectedBadges || selectedCertificates) && selectedLetters">
      <br><br><br><br>
    </div>
    <kendo-pdf-export #pdfLetter paperSize="letter" [scale]="0.75" margin="1cm" forcePageBreak=".page-break">
      <div *ngIf="selectedLetters">
        <strong>
          <div class="letterhead">
            <div class="address">
                PUBLIC HEALTH DIVISION<br>
                Center for Health Protection<br>
                <hr/>
                <span style="font-size: smaller;">Tina Kotek, Governor</span><br>
            </div>
            <div class="logo">
              <img src="../../../../../assets/images/ohaLogoTransparent.png" style="width: 20%;" alt="OHA Logo"/>
            </div>
          </div>
          <div class="bodyhead">
            <div class="persondetail">
                <p style="margin-top: -15px; margin-bottom: 5px">{{ todayDate }}</p>
                <br>
                Sent by email<br>
                {{personCertificateModel.firstName}} {{personCertificateModel.lastName}}<br>
                <div *ngIf="firmName">{{firmName}}<br></div>
                {{personAddress.street}}<br>
                {{personAddress.city}} {{personAddress.state}} {{personAddress.zip}}<br>
            </div>
            <div class="bodyaddress">                          
                800 NE Oregon Street, Suite 640<br>
                Portland, OR 97232<br>
                Phone: (971)673-0440<br>
                Fax: (971)673-0457<br>
                TTY Nonvoice: (971)673-0372<br>
            </div>
          </div>
        </strong>
        <div class="letter-content">
          
          <p><strong>RE: LEAD-BASED PAINT ACTIVITIES, INDIVIDUAL CERTIFICATION No. {{personCertificateModel.certificationNumber}}</strong></p>
            
            <p>
              This letter is your official notification that you have met the certification requirements under Oregon Administrative Rule (OAR) 333-069 to 
              conduct lead-based paint activities in Oregon, in the following discipline: <strong>{{personCertificateModel.codeType}}</strong>.
            </p>
            <p>
              In addition to this 3-year certification by the Oregon Health Authority (OHA), 
              you are required to be licensed annually by the Construction Contractors Board (CCB) 
              if you plan to conduct lead-based paint activities in Oregon unless specifically exempt from their licensing. 
              For example, units of government/public sector organizations are typically exempt from CCB licensing. 
              This applies to both firms and individuals. This license is different than, and in addition to, the standard contractor license issued by CCB. 
              For more information on CCB lead-based paint licensing, visit their web site at www.oregon.gov/CCB or call 503-378-4621.
            </p>                            
            <div style="position: relative;">
              <img src="../../../../../assets/images/transparentSeal.png" alt="Watermark" class="watermark" />
            </div>                  
            <p>
              As a certified individual in Oregon, you must meet all the requirements of OAR 333-069 and 40 Code of Federal Regulations 745 Subparts D and L, 
              as adopted by reference, including work practice standards for conducting lead-based paint activities in target housing and child-occupied facilities. 
              As a certified individual, you must perform work under a firm that is certified by OHA for conducting lead-based paint activities. 
            <strong> Also, you are required to attend 8-hour refresher training at least once every three years.</strong>                            
            </p>
            <p>
              Please note that your badge and certificate will expire on <strong>{{personCertificateModel.expirationDate | date: 'MM/dd/yyyy'}}</strong>.
              Your badge will be mailed to you separately and must be on you while performing lead-based paint activities. 
              If you wish to maintain your certification after <strong>{{personCertificateModel.expirationDate | date: 'MM/dd/yyyy'}}</strong>, 
              submit an application postmarked at least 60 days before expiration and document that your lead-based paint activities training is current.
            </p>
            <p>
              As a public service the Authority publishes a list of individuals performing lead-based paint activities in Oregon. 
              The list is distributed statewide to consumers interested in lead-based paint services.
              Only those individuals that are certified by the state are eligible to be on this list.
            </p>
            <p>
              If you have any questions concerning your certification or other aspects of the Lead-Based Paint Program, please contact program staff at 971-673-0440.
            <br><br>            
            Sincerely,<br>
            {{loggedUser}}<br>
            Lead-Based Paint Program<br>
            Oregon Health Authority<br><br>
            <span *ngIf="(selectedBadges || selectedCertificates)">Enclosure: <span *ngIf="selectedCertificates">Certificate</span><span *ngIf="selectedCertificates && selectedBadges">, </span><span *ngIf="selectedBadges">Badge</span>
            </span></p>
        </div>
      </div>
    </kendo-pdf-export>
  </mat-dialog-content>